(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-list-infinite-scroll')) {
    customElements.define(
      'product-list-infinite-scroll',
      class ProductListInfiniteScroll extends HTMLElement {
        connectedCallback() {
          this.loading = false;
          this.nextPage = parseInt(this.dataset.nextPage, 10) || null;
          this.totalPages = parseInt(this.dataset.totalPages, 10) || Infinity;
          this.sentinel = this.querySelector('[data-infinite-scroll-sentinel]');
          this.button = this.querySelector('[data-infinite-scroll-button]');
          this.status = this.querySelector('[data-infinite-scroll-status]');
          this.grid = this.findGrid();

          this.onButtonClick = (event) => {
            event.preventDefault();
            this.loadNextPage();
          };

          if (this.button) this.button.addEventListener('click', this.onButtonClick);

          if ('IntersectionObserver' in window && this.sentinel) {
            this.observer = new IntersectionObserver(
              (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
              },
              { rootMargin: '800px 0px' }
            );
            this.observer.observe(this.sentinel);
          }
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.button) this.button.removeEventListener('click', this.onButtonClick);
        }

        findGrid() {
          const section = this.closest('.section-resource-list') || this.parentElement;
          const firstItem = section && section.querySelector('.resource-list__item');
          return firstItem ? firstItem.parentElement : null;
        }

        setStatus(message) {
          if (this.status) this.status.textContent = message;
        }

        complete() {
          this.nextPage = null;
          if (this.observer) this.observer.disconnect();
          if (this.button) this.button.remove();
          this.setStatus('');
        }

        async loadNextPage() {
          if (this.loading || !this.nextPage || this.nextPage > this.totalPages || !this.grid) return;

          this.loading = true;
          this.setAttribute('aria-busy', 'true');
          this.setStatus('Loading more products…');

          const url = `${this.dataset.baseUrl}?section_id=${encodeURIComponent(this.dataset.sectionId)}&page=${this.nextPage}`;

          try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`Section request failed with status ${response.status}`);

            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const items = doc.querySelectorAll('.resource-list__item');

            if (items.length === 0) {
              this.complete();
              return;
            }

            const fragment = document.createDocumentFragment();
            items.forEach((item) => fragment.appendChild(item));
            this.grid.appendChild(fragment);

            const marker = doc.querySelector('product-list-infinite-scroll');
            const next = marker ? parseInt(marker.dataset.nextPage, 10) : NaN;

            if (Number.isNaN(next)) {
              this.complete();
            } else {
              this.nextPage = next;
              if (this.button) this.button.href = `${this.dataset.baseUrl}?page=${next}`;
              this.setStatus('');
            }
          } catch (error) {
            console.error('[product-list] infinite scroll failed', error);
            this.setStatus('Couldn’t load more products.');
            // Stop auto-loading on failure and leave the button for a manual retry.
            if (this.observer) this.observer.disconnect();
          } finally {
            this.loading = false;
            this.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
